exports = module.exports = require("../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-6ae70e02]{background-color:#fbfbfb}.setting-body[data-v-6ae70e02]{background-color:#fdfdfd}input[data-v-6ae70e02],textarea[data-v-6ae70e02]{border-style:solid}.token_password_toggle[data-v-6ae70e02]{position:absolute;margin-top:-35px;right:35px}", ""]);

// exports
